import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import remarkDialog from "../common/remarkDialog";
import settingDialog from "../common/settingDialog";
import recycleMsgDialog from "../common/recycleMsgDialog";
import recycleDialog from "../common/recycleDialog";

export default {
  mixins: [listMixin],
  components: {
    list, remarkDialog, settingDialog, recycleMsgDialog, recycleDialog
  },
  data() {
    return {
      pddApi: {
        order: require("@/api/pdd/order").default,
        logistics: require('@/api/pdd/logistics').default,
        waybills: require('@/api/pdd/waybills').default,
      },
      fullscreen: false,
      quickCheck: null,
      temp: null,
      snField: "成团时间",
      snType: "DESC",
      sysType: "",
      mallId: "", //店铺编号
      params: {
        商品搜索: "",
        规格搜索: "",
        售后状态: null,
        备注留言: null,
        退款状态: null,
        地区选择: null,
        旗帜选择: null,
        快递公司: null,
        fieldType: "智能搜索",
        fieldValue: "",
        时间类型: "成团时间",
        startDate: this.$commonJs.getDayAgo(),
        endDate: this.$commonJs.getToday()
      },
      companiesList: [],
      // mallList: [],
      waybillList: []
    }
  },
  created() {
    this.sysType = localStorage.getItem("sys_type");
    // this.mallList = JSON.parse(localStorage.getItem("mall_list"));

    var user_info = localStorage.getItem("user-info");
    if (user_info) {
      let user = JSON.parse(user_info);
      let malls = this.$store.state.user.mallList.filter(x => x.day >= 0 && x.mallId == user.mallId);
      if (malls.length > 0) this.mallId = malls[0].mallId;
    }
  },
  computed: {
    dataMasking() {
      return this.$store.state.settings.dataMasking;
    },
    mallList() {
      return this.$store.state.user.mallList.filter(x => x.day >= 0);
    }
  },
  mounted() {
    // var loading = this.$loading({
    //   lock: true,
    //   text: "正在加载...",
    //   spinner: "el-icon-loading",
    //   customClass: "my_loading",
    //   background: "rgba(0, 0, 0, 0.3)",
    // });
    // var promises = [this.getCompanies()];
    // Promise.all(promises).then(res => {
    //   loading.close();
    //   var errlist = res.filter(x => x.errorCode != undefined)
    //   if (errlist.length > 0) this.$message.error(errlist.join("\n"));
    // }).catch(error => {
    //   console.log('All promises failed', JSON.parse(JSON.stringify(error)));
    //   loading.close();
    // });
  },
  methods: {
    setScreen() {
      this.$refs.list.setScreen();
      this.fullscreen = this.$refs.list.fullscreen;
    },
    setStyle() {
      this.$refs.list.data.forEach(x => {
        if (x.multiorder.length > 1) {
          x.multiorder.forEach(o => {
            var goods = document.getElementById("order_" + o.id);
            var height = goods.clientHeight + "px"
            var time = document.getElementById("time_" + o.id);
            if (time) time.style.height = height;
            var remark_ = document.getElementById("remark_" + o.id);
            if (remark_) remark_.style.height = height;
            var mall = document.getElementById("mall_" + o.id);
            if (mall) mall.style.height = height;
          })
        }
      })
    },
    reload() {
      this.getCompanies().then(async () => {
        this.waybillList = [];

        this.companiesList.forEach(x => {
          // if (x.quantity > 0) {
          //   this.waybillList.push({ ...x })
          // }
          this.waybillList.push({ ...x })
        })

        console.log("this.waybillList", this.waybillList)
        this.$refs.list.getData();
      })
    },
    setUnlock(data, type) {
      console.log("解锁")
      this.$confirm('确认解锁吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (!data.decryptData[type]) {
          this[this.sysType + "Api"].order.decrypt([data.orderNumber], this.mallId).then(res => {
            if (res.data) {
              data.decryptData.fullName = res.data[0].receiverName;
              data.decryptData.mobilePhone = res.data[0].receiverPhone;
              data.decryptData.detailAddress = res.data[0].receiverAddress;
              data.receiverAddress[type] = data.decryptData[type];
            } else {
              this.$message.error(res.errorMessage || "订单解密失败")
            }
          })
        } else {
          data.receiverAddress[type] = data.decryptData[type];
        }
      }).catch(() => { });
    },
    getCompanies() {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].logistics.companies(this.mallId).then(res => {
          if (!res.errorCode) this.companiesList = res.data;
          resolve();
        }).catch((err) => {
          resolve()
        })
      })
    },
    onQuickCheck(e) {
      if (e == 0) {

      }
      if (e == 1) {
        var list = this.$refs.list.data;
        this.$refs.list.setCheckRows(list);
      }
      if (e == 2) {
        this.$refs.list.setCheckRows();
      }
    },
    onAddressSelect(e) {
      console.log("地区选择", e);
      // this.data.省市区文本 = e.map(x => x.label).join("/");
      // console.log("222", this.data.省市区);
      // console.log("333", this.data.省市区文本);
    },
    openSetting() {
      this.$refs.settingDialog.open();
    },
    moreAction(command) {
      console.log("moreAction", command);
      this[command]();
    },
    //批量修改备注
    batchEditRemark() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      let ids = rows.map((item) => item.Id);
      this.$refs.remarkDialog.openEdit({ ids: ids });
    },
    //批量回收单号
    batchRecycleNumber() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      console.log("批量回收单号");
    },
    //批量锁定
    batchLock() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      console.log("批量锁定");
    },
    //批量解锁
    batchUnlock() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      console.log("批量解锁");
    },
    //批量合并订单
    batchConsolidateOrders() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      console.log("批量合并订单");
    },
    //订单导出
    exportOrders() {
      console.log("订单导出");
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var list = this.$refs.list.data.map(x => {
        return {
          a: x.receiverAddress.fullName + "，" + x.receiverAddress.mobilePhone + "，" +
            x.receiverAddress.province + x.receiverAddress.city + x.receiverAddress.district + x.receiverAddress.detailAddress,
          b: "总数量：" + x.items.map(x => x.goodsCount).reduce((a, b) => { return a + b }) + "，总价：" + x.goodsPrice + "，实收：" + x.payAmount,
          c: "商品标题" + "，" + "规格：" + "XXL" + "，" + "数量：" + 10,
          d: this.$commonJs.toDatetimeString(x.latestDeliveryOn),
          e: "状态111",
          f: "备注/旗帜12312",
          g: x.orderNumber,
          h: x.mall.mallName,
          i: "- -",
          j: "正常",
        }
      });
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['收件信息', '合计', '商品信息', '订单时间', '状态', '备注/旗帜', '订单编号', '店铺名称', '快递信息', '单号状态'];
        const filterVal = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];
        excel.export_json_to_excel({
          header: tHeader,
          data: this.formatJson(filterVal, list),
          filename: "test",
        })
        loading.close();
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
    onSnUp() {
      console.log("up", this.$route.path)
      this.snType = "ASC";
      this.$refs.list.getData()
    },
    onSnDown() {
      console.log("down")
      this.snType = "DESC";
      this.$refs.list.getData()
    },
    editRemark(data) {
      this.$refs.remarkDialog.openEdit({ ids: [data.Id], 买家备注: data.Field6_2, 卖家备注: data.Field6_3 });
    },
    onRecycle(row) {
      this.$confirm('确认回收吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var codes = row.waybillCodes.map(x => ({ waybillCode: x.waybillCode, wpCode: x.wpCode }));
        console.log("codes", codes);
        if (codes.length == 0) {
          this.$message.warning("无可回收单号");
          return;
        }
        var loading = this.$loading({
          lock: true,
          text: "正在回收...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });

        this[this.sysType + "Api"].waybills.cancelwaybill({ orderId: row.id, codes: codes }).then(res => {
          loading.close();
          if (res.error.length > 0) {
            this.$refs.recycleMsgDialog.open().then(that => {
              that.setData(res)
            });
          } else {
            var msg = `共计回收<span style="color: #67C23A;margin: 0 5px;">${res.success}</span>个。`
            this.$alert(msg, '回收成功', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
              callback: action => {
                this.reload();
              }
            });
          }
        }).catch((err) => {
          loading.close();
        })
      }).catch(() => { });
    },
    onCopy(row) {
      navigator.clipboard.writeText("test").then(() => {
        this.$message.success('复制成功');
      }).catch(err => {
        console.log('复制失败', err);
        this.$message.error('复制失败');
      });
    },
    showRecycle(row) {
      this.$refs.recycleDialog.open().then(that => {
        that.getData(row)
      });
    },
  }
}